"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var p4_css_1 = require("p4-css");
var blockClass = p4_css_1.rule({
    d: 'inline-block',
    pos: 'absolute',
    h: '100%',
    minH: '5px',
});
exports.Rail = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'red' : _b, value = _a.value, skip = _a.skip;
    var style = {
        background: color,
        width: value * 100 + "%",
    };
    if (skip) {
        style.marginLeft = skip + "%";
    }
    return React.createElement("span", { className: blockClass, style: style });
};
